export const tomos = [
  {
    id: 'T1',
    name: 'Cimientos y Adaptación',
    months: 'Semanas 1-8',
    content:
      'La base que todo grupo necesita. Técnica, hábito y confianza desde la primera clase. Patrones funcionales, control respiratorio y activación progresiva para preparar al grupo al alto rendimiento.',
    icon: '📘',
  },
  {
    id: 'T2',
    name: 'Resistencia Metabólica',
    months: 'Semanas 9-16',
    content:
      'AMRAP, EMOM, Tabata doble y circuitos de alta densidad. El bloque que construye resistencia real y eleva el VO2 max del grupo semana a semana.',
    icon: '📗',
  },
  {
    id: 'T3',
    name: 'Fuerza y Potencia',
    months: 'Semanas 17-24',
    content:
      'Tempo training, contraste fuerza-potencia y pliometría progresiva. Donde los cuerpos cambian: más explosividad, más tono, más resultados visibles.',
    icon: '📙',
  },
  {
    id: 'T4',
    name: 'HIIT Quema-Grasa Extremo',
    months: 'Semanas 25-32',
    content:
      'EPOC Training, Sprint Intervals y Tabata Extremo. El tomo más intenso del sistema. Pensado para acelerar resultados estéticos y de rendimiento.',
    icon: '📕',
  },
  {
    id: 'T5',
    name: 'Tabatas y Protocolos Especiales',
    months: 'Semanas 33-40',
    content:
      'Tabata científico, Gibala Protocol, BPM Method y El Gran Desafío del Año: la clase que tu grupo va a recordar para siempre.',
    icon: '📓',
  },
  {
    id: 'T6',
    name: 'Retención, Nutrición y Cierre de Año',
    months: 'Semanas 41-52',
    content:
      'La clase de cierre que fideliza, la evaluación final medible y el sistema de renovación para que tu grupo se inscriba al próximo ciclo sin dudarlo.',
    icon: '📔',
  },
]

export const bonuses = [
  {
    id: '01',
    icon: '⚡',
    name: 'Kit Express de Clases Imprevistas',
    desc: '12 clases listas para cuando no llegaste a planificar. Imprimís y das.',
    value: '$9.900',
  },
  {
    id: '02',
    icon: '🧱',
    name: 'Banco de Bloques HIIT para Combinar',
    desc: '30 bloques modulares para crear clases nuevas en minutos sin repetirte.',
    value: '$8.500',
  },
  {
    id: '03',
    icon: '✅',
    name: 'Checklist Maestra del Profe HIIT Pro',
    desc: '15 checklists para entrar a cada clase con control total.',
    value: '$7.500',
  },
  {
    id: '04',
    icon: '🎯',
    name: 'Guía de Variantes por Nivel',
    desc: '24 ejercicios con versión básica, media y avanzada para grupos mixtos.',
    value: '$8.000',
  },
  {
    id: '05',
    icon: '🎤',
    name: '50 Aperturas y Cierres de Clase',
    desc: 'Para sonar profesional en cada turno sin repetirte una sola vez.',
    value: '$6.500',
  },
  {
    id: '06',
    icon: '📅',
    name: 'Planificador Semanal Listo para Imprimir',
    desc: 'Organizá toda la semana en 10 minutos el domingo. Sin estrés.',
    value: '$5.500',
  },
]

export const faqs = [
  {
    q: '¿Cómo recibo el material?',
    a: 'Recibís acceso inmediato por email, en menos de 5 minutos después de tu compra. Lo abrís desde el celular, la computadora o la tablet. Es tuyo para siempre.',
  },
  {
    q: '¿Sirve para grupos mixtos?',
    a: 'Sí. Cada clase trae variantes por nivel (básico, intermedio y avanzado) para que adaptes la misma sesión a todo tu grupo, sin importar la condición de cada alumno.',
  },
  {
    q: '¿Necesito equipamiento?',
    a: 'No es necesario. La mayoría de las clases se aplican sin implementos. Las que los usan requieren solo una silla, mochila o banda elástica.',
  },
  {
    q: '¿Hay mensualidad?',
    a: 'No. Es un pago único. El sistema completo queda tuyo para siempre y lo usás todas las veces que quieras, en todos tus turnos.',
  },
  {
    q: '¿La garantía es real?',
    a: 'Totalmente. Tenés 7 días de garantía. Si no es lo que esperabas, escribís a compradigitalyaa@gmail.com y te devolvemos el 100%. Sin formularios ni vueltas.',
  },
]

export const purchaseNotifications = [
  { name: 'Valeria R.', city: 'Buenos Aires', plan: 'Combo Completo HIIT Pro' },
  { name: 'Marcos T.', city: 'Rosario', plan: 'Combo Completo HIIT Pro' },
  { name: 'Carolina F.', city: 'Córdoba', plan: 'Combo Completo HIIT Pro' },
  { name: 'Agustín M.', city: 'Mendoza', plan: 'Combo Completo HIIT Pro' },
  { name: 'Daniela K.', city: 'La Plata', plan: 'Combo Completo HIIT Pro' },
  {
    name: 'Federico G.',
    city: 'Mar del Plata',
    plan: 'Combo Completo HIIT Pro',
  },
  { name: 'Lucía S.', city: 'Salta', plan: 'Combo Completo HIIT Pro' },
  { name: 'Nicolás P.', city: 'Tucumán', plan: 'Combo Completo HIIT Pro' },
  { name: 'Romina V.', city: 'Neuquén', plan: 'Combo Completo HIIT Pro' },
  {
    name: 'Sebastián L.',
    city: 'Bahía Blanca',
    plan: 'Combo Completo HIIT Pro',
  },
]
